import {Dialog} from '@primer/react'
import type {RefObject} from 'react'

export function TaskPinErrorDialog({
  error,
  onClose,
  returnFocusRef,
}: {
  error?: string
  onClose: () => void
  returnFocusRef?: RefObject<HTMLElement | null>
}) {
  if (!error) return null
  return (
    <Dialog
      title="Couldn’t update pinned session"
      onClose={onClose}
      returnFocusRef={returnFocusRef}
      footerButtons={[{content: 'Close', onClick: onClose}]}
    >
      <p>{error}</p>
    </Dialog>
  )
}
